import { render } from "./roomList.vue?vue&type=template&id=981561ca&scoped=true"
import script from "./roomList.vue?vue&type=script&lang=js"
export * from "./roomList.vue?vue&type=script&lang=js"

import "./roomList.vue?vue&type=style&index=0&id=981561ca&scoped=true&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-981561ca"]])

export default __exports__